import React from "react";

export default class CoworkersInUnitDropDown extends React.Component {
  render() {
    const { onChange, coworkers, coworkerId } = this.props;
    if (!coworkers) return <div />;

    return (
      <select
        name="manager-coworkers"
        aria-label="manager-coworkers"
        defaultValue={coworkerId && coworkerId.toLowerCase()}
        onChange={onChange}
        ref={(select) => {
          this.dropDown = select;
        }}
      >
        {coworkers.map((coworker) =>
          coworker.personalID ? (
            <option
              value={coworker.personalID.toLowerCase()}
              key={coworker.personalID.toLowerCase()}
            >
              {`${coworker.firstName} ${coworker.lastName}`}
            </option>
          ) : null,
        )}
      </select>
    );
  }
}
